import { gql } from '@apollo/client';

export const TASK_LIST_REMOVE_ASSIGNMENT = gql`
  mutation TaskListAssignmentDelete($taskListId: ID!, $userId: ID!) {
    taskListAssignmentDelete(
      input: { taskListId: $taskListId, userId: $userId }
    ) {
      unassignedUser {
        id
        name
        avatar
        initials
      }
      errors {
        message
      }
    }
  }
`;
export const TASK_LIST_CREATE_ASSIGNMENT = gql`
  mutation TaskListCreateAssignment($input: TaskListAssignmentCreateInput!) {
    taskListAssignmentCreate(input: $input) {
      assignedUser {
        id
        avatar
        emailAddress
        firstName
        lastName
        initials
        name
      }
      errors {
        message
      }
    }
  }
`;
